/**
 * Bilingual copy for the sr-only/aria labels of the Menu component.
 * Menu item labels come from the `items` prop and are not handled here.
 */
export const en = {
  facebook: 'Facebook',
  linkedin: 'LinkedIn',
  documentations: 'Documentations',
  openMainMenu: 'Open main menu',
};

export type Copy = typeof en;

export const km: Copy = {
  facebook: 'Facebook',
  linkedin: 'LinkedIn',
  documentations: 'ឯកសារណែនាំ',
  openMainMenu: 'បើកម៉ឺនុយសំខាន់',
};
